import type { SistemaDeAmortizacao } from './configuracoes';

/** O que cada sistema faz com a parcela, em duas frases — para quem simula ou fecha o contrato. */
const EXPLICACAO: Readonly<Record<SistemaDeAmortizacao, string>> = {
  sac: 'SAC (Sistema de Amortização Constante): a dívida é abatida em partes iguais e os juros incidem sobre o saldo, que vai caindo — a primeira parcela é a maior e as seguintes diminuem. No total, paga menos juros que a Price.',
  price:
    'Price (Tabela Price): todas as parcelas têm o mesmo valor. No começo, cada parcela leva mais juros e abate menos dívida; com o tempo, isso se inverte. No total, paga mais juros que o SAC.',
};

/** A taxa como digitada no campo ("1", "1,5"); `null` quando não é número. */
function taxaDigitada(texto: string): number | null {
  const valor = Number(texto.trim().replace(',', '.'));
  return texto.trim() === '' || !Number.isFinite(valor) ? null : valor;
}

/**
 * A explicação do sistema escolhido, embaixo do campo. Com juros zero, os dois
 * dão as mesmas parcelas — e a tela diz, em vez de deixar parecer que a escolha
 * muda alguma coisa.
 */
export function explicacaoDoSistema(
  sistema: SistemaDeAmortizacao,
  taxaJurosMensal: string,
): string {
  return taxaDigitada(taxaJurosMensal) === 0
    ? `${EXPLICACAO[sistema]} Com juros de 0%, os dois sistemas dão as mesmas parcelas.`
    : EXPLICACAO[sistema];
}
